// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mrbox label[data-v-1bc1562c]{width:100%;color:#fff}.controlrow.edit textbox[data-v-1bc1562c]{width:100%}button[data-v-1bc1562c]:disabled,button[data-v-1bc1562c]:disabled:hover{background:#dddddddd}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
